export default "__VITE_ASSET__CdbCBCPs__"